import React, { PropsWithChildren, useEffect, useState } from 'react';

import { Modal } from '@swyftx/aviary/atoms/Modal';
import { EnhancedTabs } from '@swyftx/aviary/molecules/EnhancedTabs';
import { MarginOrderDirection, MarginOrderType } from '@swyftx/margin/build/types';

import { MarginOrderCloseType } from 'src/lib/margin/types';

import { ClosingPositionsContent } from './ClosingPositionsContent';
import { OpeningPositionsContent } from './OpeningPositionsContent';

type Props = {
  defaultValue?: 'opening' | 'closing';
  marginDirection?: MarginOrderDirection;
  marginType?: MarginOrderType;
  closeType?: MarginOrderCloseType;
};

const MarginTradeTypeTooltipModal: React.FC<PropsWithChildren<Props>> = ({
  defaultValue = 'opening',
  marginDirection,
  marginType,
  closeType,
  children,
}) => {
  const [tabValue, setTabValue] = useState<string>(defaultValue.toString());

  useEffect(() => {
    setTabValue(defaultValue.toString());
  }, [defaultValue]);

  return (
    <Modal
      triggerElement={children}
      title='Order types explained'
      className='lg:max-w-[600px]'
      position='dynamic'
      overlayClassName='z-modal-popover-backdrop'
    >
      <div className='sticky top-[-1px] z-10 border-b border-color-border-main bg-color-background-surface-primary px-16 md:px-24'>
        <EnhancedTabs
          variant='parent'
          value={tabValue}
          tabs={[
            { title: 'Opening positions', value: 'opening' },
            { title: 'Closing positions', value: 'closing' },
          ]}
          size='lg'
          onChange={setTabValue}
        />
      </div>
      {tabValue === 'opening' && <OpeningPositionsContent marginDirection={marginDirection} marginType={marginType} />}
      {tabValue === 'closing' && <ClosingPositionsContent marginDirection={marginDirection} closeType={closeType} />}
    </Modal>
  );
};

export { MarginTradeTypeTooltipModal };
